import { LanguageCode } from "./LanguageCode";

export const LocalizedImageMixin = {
  methods: {
    localizedSource(src) {
      let context = this.getContext();
      let code = LanguageCode.getLanguage(this.$i18n.locale);
      return context("./" + src.split("{locale}").join(code));
    },
    /**
     * @return require.context Return the context from which to fetch the localized source
     */
    getContext() {
      throw new Error(
        this.constructor.name + " does not implement getContext()!"
      );
    }
  }
};
